<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'BuyGamePassStat',
  props: {
    title: {
      type: String,
      default: '购买量'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['#1E90FF', 'red'],
        title: {
          text: '当日购买'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['购买次数', '购买率'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          name: '购买量',
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }, {
          name: '购买率',
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '购买量',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '购买率',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          }
        ]
      }
    },
    refresh(data, dayData) {
      const time = []
      const user = []
      const rate = []
      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(val.date))
        user.push(val.count)
        for (const k in dayData) {
          const val2 = dayData[k]
          if (val.date === val2.date) {
            let _rate = 0.0
            if (val2.log_count > 0) {
              _rate = val.count / val2.log_count * 100
            }
            rate.push(_rate.toFixed(2))
          }
        }
      }

      this.option.xAxis.data = time
      this.option.series[0].data = user
      this.option.series[1].data = rate
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
